module.exports = __webpack_public_path__ + "media/tang_1.7551c340.mp4";